import FCMService from "./FCMService";
import LocalStorageService from "./LocalStorageService";

const GRANTED = 'granted'
const DENIED = 'denied'

class NotificationService{

    getNotificationPermission(): boolean {
        if (!('Notification' in window))
         return false
         
        if (Notification.permission === 'granted') {
            return LocalStorageService.getItem('notif_perm') == GRANTED
        } else {
            return false
        }
    }

    toggleNotificationPermission(input: boolean) {
        FCMService.generateToken()
        if (Notification.permission === 'granted') {
            LocalStorageService.updateStorage('notif_perm', input ? 'granted' : 'denied');
        } else if (Notification.permission === 'denied') {
            LocalStorageService.updateStorage('notif_perm', 'denied');
        } else if (Notification.permission === 'default') {
            Notification.requestPermission(function(choice) {
                if (choice === 'granted') {
                    LocalStorageService.updateStorage('notif_perm', input? GRANTED : DENIED);
                } else {
                    LocalStorageService.updateStorage('notif_perm', DENIED);
                }
            });
        }
    }
}

export default new NotificationService()